import React from 'react';
import { motion } from 'framer-motion';
export function AboutHome() {
  return <section id="about" className="py-24 md:py-32 bg-cream border-t border-sand/20" data-id="element-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-11">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-12">
          {/* Image Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-13">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden border border-sand/30" data-id="element-14">
              <img src="https://cdn.magicpatterns.com/uploads/su227PdRESX19csTapMkAj/chuck-1.webp" alt="Covered patio with boulder views at 38809 N Boulder View Dr" className="w-full h-full object-cover" data-id="element-15" />
            </div>
            <div className="absolute -bottom-10 -right-6 md:-right-10 w-2/3 aspect-[4/3] rounded-2xl overflow-hidden border-4 border-cream shadow-xl" data-id="element-16">
              <img src="https://cdn.magicpatterns.com/uploads/dDWVMLJL18WJdWuFqEPwMh/chuck-2.webp" alt="Chef's kitchen with granite islands and custom cabinetry" className="w-full h-full object-cover" data-id="element-17" />
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-sand/10 rounded-full blur-2xl -z-10" data-id="element-18"></div>
          </motion.div>

          {/* Copy Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex flex-col items-start" data-id="element-19">
            <span className="text-sand uppercase tracking-widest text-sm mb-4" data-id="element-20">
              The Property
            </span>
            <h2 className="text-4xl md:text-5xl font-serif text-stone-deep mb-8 leading-tight" data-id="element-21">
              A Rare Opportunity <br data-id="element-22" /> in North Scottsdale
            </h2>

            <div className="space-y-6 text-lg text-stone-deep/80 leading-relaxed mb-10" data-id="element-23">
              <p data-id="element-24">
                Nestled among ancient boulder formations, this architectural
                masterpiece redefines luxury desert living. Floor-to-ceiling
                glass walls blur the lines between indoors and out, framing
                uninterrupted views of the Sonoran Desert and distant mountain
                ranges.
              </p>
              <p data-id="element-25">
                The open-concept floor plan is designed for both grand
                entertaining and intimate daily life, featuring a chef's
                kitchen, custom stonework, and warm wood accents throughout.
              </p>
              <p data-id="element-26">
                Step outside to your private resort-style oasis, complete with
                an infinity-edge pool, multiple fire features, and expansive
                covered patios—all just minutes from world-class golf, fine
                dining, and the charming downtown of North Scottsdale.
              </p>
            </div>

            <a href="#schedule" className="inline-block border-b-2 border-brown text-brown uppercase tracking-widest text-sm font-medium pb-1 hover:text-stone-deep hover:border-stone-deep transition-colors duration-300" data-id="element-27">
              See Full Property Details
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}